import React, { Component } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Form,
    Label,
    Input,
    Button,
    Spinner,
    Alert
} from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import config from "../../config/config";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import withRouter from "../../components/Common/withRouter";
import "./educationalTours.scss";

class EditEducationalTour extends Component {
    selectStyles = {
        control: (provided, state) => ({
            ...provided,
            borderColor: state.isFocused ? "#556ee6" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(85,110,230,.25)" : "none",
            "&:hover": {
                borderColor: "#556ee6",
            },
            minHeight: "38px",
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#f1f1f1",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#556ee6"
                : state.isFocused
                    ? "#e9ecef"
                    : "white",
            color: state.isSelected ? "white" : "#495057",
            cursor: "pointer",
        }),
    };

    constructor(props) {
        super(props);
        this.state = {
            breadcrumbItems: [
                { title: "Educational Tours", link: "/educational-tours" },
                { title: "Edit Educational Tour", link: "#" },
            ],
            categories: [],
            trendingCategories: [],
            destinations: [],
            inclusions: [],
            exclusions: [],
            selectedCategory: "",
      selectedTourCategory: "",
            selectedTrendingCategory: "",
            selectedDestinations: [],
            selectedInclusions: [],
            selectedExclusions: [],
            dayWiseDescriptions: [{ day: 1, title: "", sightseeing_included: "", inclusion: "", activities: [{ text: "", image: null, imagePreview: null }] }],
            tourName: "",
            tourDescription: "",
            duration: "",
            price: "",
            priceBasis: "Per Person Twin Sharing",
            tourImage: null,
            imagePreview: null,
            existingImage: "",
            loading: true,
            error: null,
            submitting: false,
            errors: {},
        };
    }

    componentDidMount() {
        this.fetchCategories();
        this.fetchTrendingCategories();
        this.fetchInclusions();
        this.fetchExclusions();
        this.fetchDestinations();
    }

    fetchInclusions = async () => {
        try {
            const res = await fetch(`${config.API_BASE_URL}/tourinclusions`, {
                headers: { "ngrok-skip-browser-warning": "true" },
            });
            const data = await res.json();
            if (res.ok) {
                const options = (Array.isArray(data) ? data : []).map(inc => ({
                    value: inc.tourinclusion_name,
                    label: inc.tourinclusion_name
                }));
                this.setState({ inclusions: options });
            }
        } catch (err) {
            console.error("Error fetching inclusions:", err);
        }
    };

    fetchExclusions = async () => {
        try {
            const res = await fetch(`${config.API_BASE_URL}/tourexclusions`, {
                headers: { "ngrok-skip-browser-warning": "true" },
            });
            const data = await res.json();
            if (res.ok) {
                const options = (Array.isArray(data) ? data : []).map(exc => ({
                    value: exc.tourexclusion_name,
                    label: exc.tourexclusion_name
                }));
                this.setState({ exclusions: options });
            }
        } catch (err) {
            console.error("Error fetching exclusions:", err);
        }
    };

    fetchCategories = async () => {
        try {
            const res = await fetch(`${config.API_BASE_URL}/categories`, {
                headers: { "ngrok-skip-browser-warning": "true" },
            });
            const data = await res.json();
            if (res.ok) this.setState({ categories: data });
        } catch (err) {
            console.error("Error fetching categories:", err);
        }
    };

    fetchDestinations = async () => {
        try {
            const res = await fetch(`${config.API_BASE_URL}/destinations`, {
                headers: { "ngrok-skip-browser-warning": "true" },
            });
            const data = await res.json();
            if (res.ok) {
                const options = (Array.isArray(data) ? data : []).map(dest => ({
                    value: dest._id,
                    label: dest.destination_name
                }));
                this.setState({ destinations: options }, this.fetchTourData);
            }
        } catch (err) {
            console.error("Error fetching destinations:", err);
        }
    };

    fetchTrendingCategories = async () => {
        try {
            const res = await fetch(`${config.API_BASE_URL}/trending-categories`, {
                headers: { "ngrok-skip-browser-warning": "true" },
            });
            const data = await res.json();
            if (res.ok) {
                this.setState({ trendingCategories: data.data || data });
            }
        } catch (err) {
            console.error("Error fetching trending categories:", err);
        }
    };

    fetchTourData = async () => {
        try {
            const tourId = this.props.router.params.id;
            const res = await fetch(`${config.API_BASE_URL}/educational-tours/${tourId}`, {
                headers: { "ngrok-skip-browser-warning": "true" },
            });
            const data = await res.json();

            if (res.ok) {
                const tourData = data.data || data;
                
                const inclusionOptions = (tourData.includes || []).map(inc => ({
                    value: inc,
                    label: inc
                }));

                const exclusionOptions = (tourData.excludes || []).map(exc => ({
                    value: exc,
                    label: exc
                }));

                const matchedDestinations = (tourData.destinations || []).map(destId => {
                    const idToFind = typeof destId === 'object' ? destId._id : destId;
                    const found = this.state.destinations.find(d => d.value === idToFind);
                    return found || null;
                }).filter(Boolean);

                const dayWiseDescriptions = tourData.dayWiseDescriptions && tourData.dayWiseDescriptions.length > 0
                    ? tourData.dayWiseDescriptions.map((day) => ({
                        ...day,
                        activities: day.activities.map((activity) => {
                            if (typeof activity === 'string') {
                                return { text: activity, image: null, imagePreview: null };
                            }
                            const activityImage = activity.activity_image || activity.image || null;
                            const isPlaceholder = activityImage && activityImage.startsWith('activity_');
                            return {
                                text: activity.description || activity.text || "",
                                image: null,
                                imagePreview: null,
                                existingImage: isPlaceholder ? null : activityImage
                            };
                        })
                    }))
                    : [{ day: 1, title: "", activities: [{ text: "", image: null, imagePreview: null }] }];

                this.setState({
                    tourName: tourData.tour_name || tourData.title || "",
                    selectedCategory: tourData.category_name || "",
                    selectedTrendingCategory: tourData.trendingCategoryId?._id || tourData.trendingCategoryId || "",
                    duration: tourData.duration || "",
                    price: tourData.price || "",
                    priceBasis: tourData.price_basis || "Per Person Twin Sharing",
                    tourDescription: tourData.description || "",
                    existingImage: tourData.tour_image ? `${config.IMAGE_URL}/${tourData.tour_image}` : "",
                    selectedInclusions: inclusionOptions,
                    selectedExclusions: exclusionOptions,
                    selectedDestinations: matchedDestinations,
                    dayWiseDescriptions,
                    loading: false
                });
            } else {
                this.setState({ error: "Educational tour not found", loading: false });
            }
        } catch (err) {
            console.error("Error fetching educational tour data:", err);
            this.setState({ error: "Failed to load educational tour data", loading: false });
        }
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
            errors: { ...this.state.errors, [name]: null }
        });
    };

    handleInclusionsChange = (selectedOptions) => {
        this.setState({ selectedInclusions: selectedOptions || [] });
    };

    handleExclusionsChange = (selectedOptions) => {
        this.setState({ selectedExclusions: selectedOptions || [] });
    };

    handleDestinationsChange = (selectedOptions) => {
        this.setState({
            selectedDestinations: selectedOptions || [],
            errors: { ...this.state.errors, selectedDestinations: null }
        });
    };

    handleDayTitleChange = (dayIndex, value) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        updatedDays[dayIndex].title = value;
        this.setState({ dayWiseDescriptions: updatedDays });
    };

    handleSightseeingChange = (dayIndex, value) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        updatedDays[dayIndex].sightseeing_included = value;
        this.setState({ dayWiseDescriptions: updatedDays });
    };

    handleDayInclusionChange = (dayIndex, value) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        updatedDays[dayIndex].inclusion = value;
        this.setState({ dayWiseDescriptions: updatedDays });
    };

    handleActivityChange = (dayIndex, activityIndex, value) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        updatedDays[dayIndex].activities[activityIndex].text = value;
        this.setState({ dayWiseDescriptions: updatedDays });
    };

    handleActivityImageChange = (dayIndex, activityIndex, file) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        if (file) {
            updatedDays[dayIndex].activities[activityIndex].image = file;
            updatedDays[dayIndex].activities[activityIndex].imagePreview = URL.createObjectURL(file);
        } else {
            updatedDays[dayIndex].activities[activityIndex].image = null;
            updatedDays[dayIndex].activities[activityIndex].imagePreview = null;
        }
        this.setState({ dayWiseDescriptions: updatedDays });
    };

    addActivity = (dayIndex) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        updatedDays[dayIndex].activities.push({ text: "", image: null, imagePreview: null });
        this.setState({ dayWiseDescriptions: updatedDays });
    };

    removeActivity = (dayIndex, activityIndex) => {
        const updatedDays = [...this.state.dayWiseDescriptions];
        if (updatedDays[dayIndex].activities.length > 1) {
            updatedDays[dayIndex].activities.splice(activityIndex, 1);
            this.setState({ dayWiseDescriptions: updatedDays });
        }
    };

    addDay = () => {
        const newDay = {
            day: this.state.dayWiseDescriptions.length + 1,
            title: "",
            sightseeing_included: "",
            inclusion: "",
            activities: [{ text: "", image: null, imagePreview: null }],
        };
        this.setState({
            dayWiseDescriptions: [...this.state.dayWiseDescriptions, newDay],
        });
    };

    removeDay = (index) => {
        if (this.state.dayWiseDescriptions.length > 1) {
            const updatedDays = this.state.dayWiseDescriptions.filter((_, i) => i !== index);
            const renumberedDays = updatedDays.map((day, i) => ({ ...day, day: i + 1 }));
            this.setState({ dayWiseDescriptions: renumberedDays });
        }
    };

    handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            this.setState({
                tourImage: file,
                imagePreview: URL.createObjectURL(file),
                errors: { ...this.state.errors, tourImage: null }
            });
        }
    };

    validateForm = () => {
        const errors = {};
        if (!this.state.selectedCategory) {
            errors.selectedCategory = "Please select a State/Country Name";
        }
        if (!this.state.tourName.trim()) {
            errors.tourName = "Please enter a Tour Name";
        }
        if (!this.state.selectedDestinations || this.state.selectedDestinations.length === 0) {
            errors.selectedDestinations = "Please select at least one destination";
        }
        if (!this.state.tourDescription.trim()) {
            errors.tourDescription = "Please enter a tour description";
        }
        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };

    handleSubmit = async (e) => {
        e.preventDefault();

        if (!this.validateForm()) {
            return;
        }

        this.setState({ submitting: true, errors: {} });

        try {
            const formData = new FormData();
            formData.append("category_name", this.state.selectedCategory);
      if (this.state.selectedTourCategory) {
        formData.append("tour_category", this.state.selectedTourCategory);
      }
            if (this.state.selectedTrendingCategory) {
                formData.append("trendingCategoryId", this.state.selectedTrendingCategory);
            }
            formData.append("tour_name", this.state.tourName);
            if (this.state.duration) {
                formData.append("duration", this.state.duration);
            }

            this.state.selectedDestinations.forEach(dest => {
                formData.append("destinations[]", dest.value);
            });

            if (this.state.price) {
                formData.append("price", this.state.price);
            }
            if (this.state.priceBasis) {
                formData.append("price_basis", this.state.priceBasis);
            }

            this.state.selectedInclusions.forEach(inc => {
                formData.append("includes[]", inc.value);
            });

            this.state.selectedExclusions.forEach(exc => {
                formData.append("excludes[]", exc.value);
            });

            const hasValidDayWiseContent = this.state.dayWiseDescriptions.some(day => 
                day.title.trim() || day.activities.some(activity => activity.text.trim())
            );

            if (hasValidDayWiseContent) {
                const dayWiseData = this.state.dayWiseDescriptions.map((day, dayIndex) => ({
                    day: day.day,
                    title: day.title,
                    sightseeing_included: day.sightseeing_included || "",
                    inclusion: day.inclusion || "",
                    activities: day.activities
                        .map((activity, activityIndex) => ({
                            description: (activity.text || "").trim(),
                            activity_image: activity.image 
                                ? `activity_${dayIndex}_${activityIndex}` 
                                : (activity.existingImage || null)
                        }))
                        .filter(act => act.description || act.activity_image)
                }));

                formData.append("dayWiseDescriptions", JSON.stringify(dayWiseData));

                this.state.dayWiseDescriptions.forEach((day, dayIndex) => {
                    day.activities.forEach((activity, activityIndex) => {
                        if (activity.image) {
                            const fieldName = `activity_${dayIndex}_${activityIndex}`;
                            formData.append(fieldName, activity.image);
                        }
                    });
                });
            }

            formData.append("description", this.state.tourDescription);

            if (this.state.tourImage) {
                formData.append("tour_image", this.state.tourImage);
            }

            const tourId = this.props.router.params.id;
            const res = await fetch(`${config.API_BASE_URL}/educational-tours/${tourId}`, {
                method: "PUT",
                headers: { "ngrok-skip-browser-warning": "true" },
                body: formData,
            });

            const data = await res.json();

            if (res.ok) {
                alert("Educational Tour updated successfully!");
                this.props.router.navigate("/educational-tours");
            } else {
                this.setState({ 
                    errors: { submit: data.message || "Failed to update educational tour" },
                    submitting: false 
                });
            }
        } catch (err) {
            console.error("Error updating educational tour:", err);
            this.setState({ 
                errors: { submit: "Error updating educational tour" },
                submitting: false 
            });
        }
    };

    handleCancel = () => {
        this.props.router.navigate("/educational-tours");
    };

    render() {
        const { loading, error, existingImage, imagePreview, submitting, destinations, selectedDestinations, selectedInclusions, inclusions } = this.state;

        if (loading) {
            return (
                <div className="page-content">
                    <Container fluid>
                        <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
                            <Spinner color="primary" />
                        </div>
                    </Container>
                </div>
            );
        }

        return (
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Edit Educational Tour" breadcrumbItems={this.state.breadcrumbItems} />

                    {error && <Alert color="danger" className="mb-3">{error}</Alert>}

                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <Form onSubmit={this.handleSubmit}>
                                        <Row>
                                            {/* Category */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">State / Country Name <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="select"
                                                        value={this.state.selectedCategory}
                                                        onChange={(e) => this.setState({ selectedCategory: e.target.value })}
                                                        required
                                                    >
                                                        <option value="">Select State / Country Name</option>
                                                        {this.state.categories.map((cat) => (
                                                            <option key={cat._id || cat.id} value={cat.category_name}>
                                                                {cat.category_name}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </div>
                                            </Col>

                                            {/* Trending Category */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Trending Category</Label>
                                                    <Input
                                                        type="select"
                                                        value={this.state.selectedTrendingCategory}
                                                        onChange={(e) => this.setState({ selectedTrendingCategory: e.target.value })}
                                                    >
                                                        <option value="">Select Trending Category</option>
                                                        {this.state.trendingCategories.map((trendingCat) => (
                                                            <option key={trendingCat._id || trendingCat.id} value={trendingCat._id || trendingCat.id}>
                                                                {trendingCat.name}
                                                            </option>
                                                        ))}
                                                    </Input>
                                                </div>
                                            </Col>

                                            {/* Tour Name */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Tour Name <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="tourName"
                                                        value={this.state.tourName}
                                                        onChange={this.handleInputChange}
                                                        required
                                                    />
                                                </div>
                                            </Col>

                                            {/* Duration */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Duration</Label>
                                                    <Input
                                                        type="text"
                                                        name="duration"
                                                        value={this.state.duration}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </div>
                                            </Col>

                                            {/* Destinations */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Destinations <span className="text-danger">*</span></Label>
                                                    <Select
                                                        isMulti
                                                        name="destinations"
                                                        options={destinations}
                                                        value={selectedDestinations}
                                                        onChange={this.handleDestinationsChange}
                                                        placeholder="Select destinations..."
                                                        isClearable
                                                        isSearchable
                                                        classNamePrefix="react-select"
                                                        styles={this.selectStyles}
                                                    />
                                                </div>
                                            </Col>

                                            {/* Price */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Price (INR)</Label>
                                                    <Input
                                                        type="number"
                                                        name="price"
                                                        value={this.state.price}
                                                        onChange={this.handleInputChange}
                                                    />
                                                </div>
                                            </Col>

                                            {/* Price Basis */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Price Basis</Label>
                                                    <Input
                                                        type="select"
                                                        name="priceBasis"
                                                        value={this.state.priceBasis}
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option value="Per Person Twin Sharing">Per Person Twin Sharing</option>
                                                        <option value="Per Person Single Occupancy">Per Person Single Occupancy</option>
                                                        <option value="Per Couple">Per Couple</option>
                                                        <option value="Per Family">Per Family</option>
                                                    </Input>
                                                </div>
                                            </Col>

                                            {/* Includes */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Includes</Label>
                                                    <Select
                                                        isMulti
                                                        name="includes"
                                                        options={inclusions}
                                                        value={selectedInclusions}
                                                        onChange={this.handleInclusionsChange}
                                                        placeholder="Select inclusions..."
                                                        isClearable
                                                        isSearchable
                                                        classNamePrefix="react-select"
                                                        styles={this.selectStyles}
                                                    />
                                                </div>
                                            </Col>

                                            {/* Excludes */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Excludes</Label>
                                                    <Select
                                                        isMulti
                                                        name="excludes"
                                                        options={this.state.exclusions}
                                                        value={this.state.selectedExclusions}
                                                        onChange={this.handleExclusionsChange}
                                                        placeholder="Select exclusions..."
                                                        isClearable
                                                        isSearchable
                                                        classNamePrefix="react-select"
                                                        styles={this.selectStyles}
                                                    />
                                                </div>
                                            </Col>

                                            {/* Description */}
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Description <span className="text-danger">*</span></Label>
                                                    <Input
                                                        type="textarea"
                                                        name="tourDescription"
                                                        value={this.state.tourDescription}
                                                        onChange={this.handleInputChange}
                                                        rows="3"
                                                        required
                                                    />
                                                </div>
                                            </Col>

                                            {/* Day-wise Descriptions */}
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <Label className="form-label mb-0"><strong>Day-wise Itinerary</strong></Label>
                                                        <Button type="button" color="success" size="sm" onClick={this.addDay}>
                                                            <i className="ri-add-line"></i> Add Day
                                                        </Button>
                                                    </div>
                                                    {this.state.dayWiseDescriptions.map((day, dayIndex) => (
                                                        <Card key={dayIndex} className="mb-3">
                                                            <CardBody>
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                    <h5 className="mb-0">Day {day.day}</h5>
                                                                    {this.state.dayWiseDescriptions.length > 1 && (
                                                                        <Button type="button" color="danger" size="sm" onClick={() => this.removeDay(dayIndex)}>
                                                                            <i className="ri-delete-bin-line"></i> Remove Day
                                                                        </Button>
                                                                    )}
                                                                </div>

                                                                <div className="mb-3">
                                                                    <Label className="form-label">Day Title</Label>
                                                                    <Input
                                                                        type="text"
                                                                        value={day.title}
                                                                        onChange={(e) => this.handleDayTitleChange(dayIndex, e.target.value)}
                                                                    />
                                                                </div>

                                                                {/* Optional Day Fields */}
                                                                <Row className="mb-3">
                                                                    <Col md={6}>
                                                                        <Label className="form-label">Sight Seeing Included (Optional)</Label>
                                                                        <Input
                                                                            type="text"
                                                                            placeholder="e.g. Full day sightseeing of Port Blair"
                                                                            value={day.sightseeing_included || ""}
                                                                            onChange={(e) => this.handleSightseeingChange(dayIndex, e.target.value)}
                                                                        />
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <Label className="form-label">Inclusion (Optional)</Label>
                                                                        <Input
                                                                            type="select"
                                                                            value={day.inclusion || ""}
                                                                            onChange={(e) => this.handleDayInclusionChange(dayIndex, e.target.value)}
                                                                        >
                                                                            <option value="">Select Inclusion (Optional)</option>
                                                                            {this.state.inclusions && this.state.inclusions.map((inc, i) => (
                                                                                <option key={i} value={inc.value || inc.label || inc}>
                                                                                    {inc.label || inc.value || inc}
                                                                                </option>
                                                                            ))}
                                                                        </Input>
                                                                    </Col>
                                                                </Row>

                                                                <div className="mb-2">
                                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                                        <Label className="form-label mb-0">Activities</Label>
                                                                        <Button type="button" color="info" size="sm" onClick={() => this.addActivity(dayIndex)}>
                                                                            <i className="ri-add-line"></i> Add Activity
                                                                        </Button>
                                                                    </div>
                                                                    {day.activities.map((activity, activityIndex) => (
                                                                        <div key={activityIndex} className="mb-3 border p-3 rounded">
                                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                                <Label className="form-label mb-0">Activity {activityIndex + 1}</Label>
                                                                                {day.activities.length > 1 && (
                                                                                    <Button type="button" color="danger" size="sm" onClick={() => this.removeActivity(dayIndex, activityIndex)}>
                                                                                        <i className="ri-close-line"></i> Remove
                                                                                    </Button>
                                                                                )}
                                                                            </div>
                                                                            
                                                                            <Row>
                                                                                <Col md={8}>
                                                                                    <Input
                                                                                        type="text"
                                                                                        value={activity.text}
                                                                                        onChange={(e) => this.handleActivityChange(dayIndex, activityIndex, e.target.value)}
                                                                                    />
                                                                                </Col>
                                                                                <Col md={4}>
                                                                                    <Input
                                                                                        type="file"
                                                                                        accept="image/*"
                                                                                        onChange={(e) => this.handleActivityImageChange(dayIndex, activityIndex, e.target.files[0])}
                                                                                    />
                                                                                </Col>
                                                                            </Row>
                                                                            
                                                                            {(activity.imagePreview || activity.existingImage) && (
                                                                                <Row className="mt-2">
                                                                                    <Col md={6}>
                                                                                        <p className="text-muted mb-1">Image preview:</p>
                                                                                        <img
                                                                                            src={activity.imagePreview || `${config.IMAGE_URL}/${activity.existingImage}`}
                                                                                            alt={`Activity ${activityIndex + 1}`}
                                                                                            className="img-fluid"
                                                                                            style={{ maxHeight: "150px" }}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    ))}
                                                </div>
                                            </Col>

                                            {/* Tour Image */}
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label className="form-label">Tour Image</Label>
                                                    <Input
                                                        type="file"
                                                        onChange={this.handleImageChange}
                                                        accept="image/*"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Image Preview */}
                                        {(imagePreview || existingImage) && (
                                            <Row className="mt-3">
                                                <Col md={6}>
                                                    <p className="text-muted mb-1">Current Image:</p>
                                                    <img
                                                        src={imagePreview || existingImage}
                                                        alt="Tour Preview"
                                                        className="img-fluid"
                                                        style={{ maxHeight: "200px" }}
                                                    />
                                                </Col>
                                            </Row>
                                        )}

                                        {/* Error Messages */}
                                        {this.state.errors.submit && (
                                            <Row className="mt-3">
                                                <Col md={12}>
                                                    <div className="alert alert-danger">
                                                        {this.state.errors.submit}
                                                    </div>
                                                </Col>
                                            </Row>
                                        )}

                                        {/* Buttons */}
                                        <Row className="mt-4">
                                            <Col className="d-flex justify-content-end">
                                                <Button 
                                                    type="submit" 
                                                    color="primary" 
                                                    className="me-2"
                                                    disabled={submitting}
                                                >
                                                    {submitting ? "Updating..." : "Update Educational Tour"}
                                                </Button>
                                                <Button
                                                    type="button"
                                                    color="secondary"
                                                    onClick={this.handleCancel}
                                                    disabled={submitting}
                                                >
                                                    Cancel
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default withRouter(EditEducationalTour);
